
  import { Component } from 'vue-property-decorator'
  import { Linked } from '.'

@Component
  export default class Card extends Linked {
    show = false
  }
